module.exports = __webpack_public_path__ + "static/zinc@2x-64d071bf19b4837936d3eda96ef1760e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/zinc@2x.jpg
// module id = 875
// module chunks = 33019919093843 122353984331245